import { create } from "zustand";
import useLoadingStore from "./use-loading";
import { makeRequest } from "api/api-client";
import { HTTP } from "constants/http-method";
import { API_ENDPOINTS } from "api/endpoints";

const useEventCalendarStore = create((set) => ({
  events: [],
  addedEmployees: [],

  // Function to get employees
  getEmployees: async ({ successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.GET_EMPLOYEES,
        null,
        null
      );
      if (response.success) {
        set({
          addedEmployees: response.data?.data || [],
        });
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to get events
  getEvent: async ({ query = null, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.GET_EVENTS,
        null,
        query
      );

      if (response.success) {
        set((state) => {
          const updatedEvents = response.data?.data.map((event) => ({
            ...event,
          }));
          return {
            events: updatedEvents,
          };
        });
        successCallback && successCallback();
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to create the event
  createEvent: async ({ data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.POST,
        API_ENDPOINTS.CREATE_EVENTS,
        data
      );
      if (response.success) {
        set((state) => ({
          events: [...state.events, response.data?.data],
        }));
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to delete event
  deleteEvent: async ({ id, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.DELETE,
        API_ENDPOINTS.DELETE_EVENTS,
        null,
        null,
        id
      );

      if (response.success) {
        set((state) => ({
          events: state.events.filter((event) => event.id !== id),
        }));
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to update event
  updateEvent: async ({ id, data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.UPDATE_EVENTS,
        data,
        null,
        id
      );

      if (response.success) {
        set((state) => ({
          events: state.events.map((event) =>
            event.id === id ? { ...event, ...response.data?.data } : event
          ),
        }));
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },
}));

export default useEventCalendarStore;

// events: [...state.events, {
//   date: response.data?.data?.date,
//   description: response.data?.data?.description,
//   location: response.data?.data?.location,
//   employees: response.data?.data?.employees || [],
//   end: response.data?.data.endTime,
//   start: response.data?.data.startTime,
//   start: response.data?.data.name,
// }]
